import React, { useEffect, useRef, useState } from "react";

import "./encyclopedia.scss";
import { observer } from "mobx-react-lite";
import Footer from "../../components/footer/footer";

import { Document, Page as ReactPdfPage } from "react-pdf";

import { pdfjs } from "react-pdf";
import HTMLFlipBook from "react-pageflip";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

import YAML from "yaml";
import { z } from "zod";
import { EncyclopediaPage } from "./page/page";
import { useLocation, useNavigate } from "react-router-dom";
import { getJSDocReturnType } from "typescript";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
	"pdfjs-dist/build/pdf.worker.min.js",
	import.meta.url
).toString();

const Page = React.forwardRef(
	(
		props: { pageNumber: number; width: number },
		ref: React.LegacyRef<HTMLDivElement>
	) => {
		return (
			<div ref={ref}>
				<ReactPdfPage
					scale={1}
					pageNumber={props.pageNumber}
					width={props.width - 3}
				/>
			</div>
		);
	}
);

function useQuery() {
	const { search } = useLocation();
	return React.useMemo(() => new URLSearchParams(search), [search]);
}

function Encyclopedia() {
	const contentRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		document.title = "Энциклопедия";
	}, []);

	const letter = useQuery().get("letter");
	const navigate = useNavigate();

	const [currentPages, changeCurrentPages] = useState<string[]>([]);
	useEffect(() => {
		const getPages = async () => {
			if (!letter) return;
			const pages = await fetch(
				process.env.PUBLIC_URL + "/encyclopedia/pages/pages.yml"
			).then((r) => (r.ok ? r.text() : null));
			if (pages) {
				console.log(YAML.parse(pages));
				const parsePages = z
					.object({ pages: z.record(z.array(z.string().nonempty())) })
					.safeParse(YAML.parse(pages));
				if (parsePages.success) {
					changeCurrentPages(
						parsePages.data.pages[letter.toUpperCase()]
					);
				} else console.error(parsePages.error);
			}
		};
		getPages();
	}, [letter]);

	return (
		<>
			{letter && (
				<>
					<div className="encyclopedia_content_wrapper">
						<div className="content" ref={contentRef}>
							{currentPages &&
								currentPages.length !== 0 &&
								currentPages.map((page, i) => (
									<EncyclopediaPage pageName={page} />
								))}
						</div>
					</div>
					<div
						className="return_button"
						onClick={() => {
							navigate("/encyclopedia");
							changeCurrentPages([]);
						}}
					>
						Вернуться к алфавитному указателю
					</div>
				</>
			)}
			{!letter && (
				<div className="encyclopedia_content_wrapper">
					<div className="content small" ref={contentRef}>
						{Array.from("абвгдеёжзийклмнопрстуфхцчшщъыьэюя").map(
							(l: string) => (
								<div
									className="letter_button"
									onClick={() => {
										navigate("/encyclopedia?letter=" + l);
									}}
								>
									{l.toUpperCase()}
								</div>
							)
						)}
					</div>
				</div>
			)}
			<Footer></Footer>
		</>
	);
}

export default observer(Encyclopedia);
